import { ColDef, ValueGetterParams } from 'ag-grid-community';
import {
  createAdministratorNameCol,
  createCustomCol,
  createDateHasMinCol,
  createDateRangeCol,
  createDetailButtonColV2,
  createIdCol,
  createNumberCol,
  createStatusBadgeCol,
  createTypoCol,
} from '@/src/helpers/agColumnHelper';
import { getConnectedContent } from '@/src/models/BannerDto';

export const bannerListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateHasMinCol({
    field: 'createdAt',
    width: 231,
    minWidth: 231,
    maxWidth: 300,
    headerName: '등록 일시',
  }),

  createTypoCol({
    field: 'bannerTitle',
    width: 317,
    minWidth: 317,
    flex: 2,
    headerName: '제목',
  }),
  createDateRangeCol({
    field: 'postedAt',
    keys: ['bannerPostStartedAt', 'bannerPostEndedAt'],
    size: 'lg',
    headerName: '게시 기간',
  }),
  createStatusBadgeCol({
    field: 'bannerShowedYn',
    type: 'isViewable',
    size: 'sm',
    headerName: '노출 여부',
  }),
  createCustomCol({
    field: 'bannerConnectedType',
    cellRenderer: (params: ValueGetterParams) => {
      return params?.data ? getConnectedContent(params.data) : '-';
    },
    size: 'md',
    headerName: '연결 컨텐츠',
  }),
  createStatusBadgeCol({
    field: 'bannerMarketingYn',
    type: 'bannerMarketingYn',
    size: 'sm',
    headerName: '광고 여부',
  }),
  createNumberCol({
    field: 'bannerViewHistoryCount',
    width: 135,
    minWidth: 135,
    maxWidth: 200,
    headerName: '클릭 수',
  }),
  createAdministratorNameCol({
    headerName: '등록 관리자',
  }),
  createDetailButtonColV2(onDetailClick),
];
